module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicator-label",
    class: {
      hovered: _vm.indicator.indicatorHovered
    },
    on: {
      "mouseenter": function($event) {
        _vm.handleHover(true)
      },
      "mouseleave": function($event) {
        _vm.handleHover(false)
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.indicator.name) + "\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41fe8a5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/heat-map-legend/LegendIndicator.vue
// module id = 538
// module chunks = 1